import {
  PlayIcon,
} from "@radix-ui/react-icons";
import {
  PictureInPicture2Icon,
  PlaySquareIcon,
  UserIcon,
  Settings2Icon,
} from "lucide-react";

export const routeOptions = [
  {
    route: "/",
    name: "Início",
    icon: <PictureInPicture2Icon className="text-icon h-6 sm:h-5" />,
  },
  {
    route: "/aulas",
    name: "Aulas",
    icon: <PlaySquareIcon className="text-icon h-6 sm:h-5" />,
  },
  {
    route: "/conta",
    name: "Minha Conta",
    icon: <UserIcon className="text-icon h-6 sm:h-5" />,
  },
  {
    route: "/admin",
    name: "Administração",
    icon: <Settings2Icon className="text-icon h-6 sm:h-5" />,
    admin: true,
  },
];

export const routeOptionsLatam = routeOptions;
